import { Box, Checkbox, Flex } from "@chakra-ui/react";
import { InfoPopover } from "../../InfoPopover/InfoPopover";
import helperTexts from '../../helperTexts.json'

export const EnableSearching = ({ field, enableSearching, handleEnableSearching }) => {
    return (
        <Box
            width='310px'
            display='flex'
            alignItems="center"
        >
            <Flex justifyContent="start" w="100%" alignItems='center'>
                <Checkbox
                    isChecked={enableSearching}
                    isDisabled={field.isDisabled}
                    onChange={(e) => handleEnableSearching(e.target.checked)}
                >
                    {field.label}
                </Checkbox>
                <InfoPopover helperText={helperTexts.enableSearching} />
            </Flex>
        </Box>
    )
}